export default __webpack_public_path__ + "static/media/full.bebd4359.png";